import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Resolve } from '@angular/router';
import { LayoutService } from '../services/layout.service';
import { TexteService } from 'src/app/core/services/texte.service';

@Injectable({
    providedIn: 'root',
})
export class LangueResolverService implements Resolve<void> {
    constructor(private layoutService: LayoutService, private texteService: TexteService) { }
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): void {
        const url = state.url.replace(/^\//, '');

        if (url === 'mentions-legales' || url === 'protection-donnees') {
            this.layoutService.initLayout(false);
        } else {
            this.layoutService.initLayout(true);
        }

        this.texteService.loadLangues().subscribe(() => {
            switch (url) {
                case 'en':
                    this.texteService.selectLangue('en');
                    break;
                case 'ar':
                    this.texteService.selectLangue('ar');
                    break;
                case 'ru':
                    this.texteService.selectLangue('ru');
                    break;
                default:
                    this.texteService.selectLangue('fr');
                    break;
            }
        });
    }
}
